import { jsx as c } from "react/jsx-runtime";
import { memo as g, useEffect as y, useRef as h } from "react";
import { createPortal as v } from "react-dom";
const x = g(
  ({ checkoutUrl: e, onSuccess: r, onCancel: t, displayOptions: o }) => (y(() => {
    const s = (n) => {
      try {
        const u = new URL(e);
        if (new URL(n.origin).hostname !== u.hostname)
          return;
      } catch {
        return;
      }
      const a = L(n);
      if (!a)
        return;
      const { value: i, redirectUrl: l, referenceId: d } = a;
      i === "success" && r({ redirectUrl: l, referenceId: d }), i === "error" && t({ redirectUrl: l, referenceId: d });
    };
    return window.addEventListener("message", s), () => window.removeEventListener("message", s);
  }, [r, t, e]), /* @__PURE__ */ c(
    "iframe",
    {
      title: "Checkout screen",
      className: "ivy-embedded-checkout-screen",
      style: {
        maxHeight: o.maxHeight,
        maxWidth: o.maxWidth
      },
      sandbox: "allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation",
      allow: "clipboard-write",
      src: b(e)
    }
  ))
), b = (e) => {
  const r = new URL(e);
  return r.searchParams.set("iframe", "true"), r.toString();
}, L = (e) => {
  if (typeof e.data != "string")
    return null;
  try {
    const r = JSON.parse(e.data);
    if (typeof r != "object" || Array.isArray(r) || r === null)
      return null;
    const t = m(r.source), o = m(r.source), s = E(r.value);
    return t !== "ivy" || o === "iframe" || !s ? null : {
      value: s,
      redirectUrl: m(r.redirectUrl) ?? "",
      referenceId: m(r.referenceId) ?? ""
    };
  } catch {
    return null;
  }
}, M = (e) => typeof e == "string" && ["success", "error"].includes(e), E = (e) => M(e) ? e : null, m = (e) => typeof e == "string" ? e : null, I = ({ url: e, maxWidth: r, maxHeight: t }) => /* @__PURE__ */ c("div", { className: "ivy-modal-container", children: /* @__PURE__ */ c("div", { className: "ivy-modal-content", children: /* @__PURE__ */ c(
  "div",
  {
    className: "ivy-modal-iframe-container",
    style: {
      maxHeight: `${t}px`,
      maxWidth: `${r}px`
    },
    children: /* @__PURE__ */ c(
      "iframe",
      {
        sandbox: "allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation",
        className: "ivy-modal-checkout-screen",
        id: "ivy-modal-iframe",
        title: "Checkout screen",
        allow: "clipboard-write",
        src: e
      }
    )
  }
) }) }), R = g(
  ({ checkoutUrl: e, onSuccess: r, onCancel: t, displayOptions: o }) => {
    const s = h();
    return y(() => {
      const n = (a) => {
        try {
          const w = new URL(e);
          if (new URL(a.origin).hostname !== w.hostname)
            return;
        } catch {
          return;
        }
        const i = P(a);
        if (!i)
          return;
        const { type: l, status: d, redirectUrl: u, referenceId: p } = i;
        l === "redirect" && r({ redirectUrl: u, referenceId: p }), (l === "closeModal" || d === "error") && t({ redirectUrl: u, referenceId: p });
      };
      return window.addEventListener("message", n), () => window.removeEventListener("message", n);
    }, [r, t, e]), y(() => (s.current = getComputedStyle(document.body).overflow, document.body.style.overflow = "hidden", () => {
      s.current && (document.body.style.overflow = s.current);
    }), []), v(
      /* @__PURE__ */ c(
        I,
        {
          url: N(e),
          maxHeight: o.maxHeight || 700,
          maxWidth: o.maxWidth || 520
        }
      ),
      document.body,
      "ivy-checkout-modal"
    );
  }
), N = (e) => {
  const r = new URL(e);
  return r.searchParams.set("popup", "true"), r.toString();
}, P = (e) => {
  var s, n, a, i, l;
  if (!e.data || typeof e.data != "object" || Array.isArray(e.data) || e.data === null)
    return null;
  const r = U((s = e.data) == null ? void 0 : s.type), t = f((n = e.data) == null ? void 0 : n.source), o = H((a = e.data) == null ? void 0 : a.status);
  return t !== "ivy" || !r || !o ? null : {
    status: o,
    type: r,
    redirectUrl: f((i = e.data) == null ? void 0 : i.value) ?? "",
    referenceId: f((l = e.data) == null ? void 0 : l.referenceId) ?? ""
  };
}, C = (e) => typeof e == "string" && ["success", "error"].includes(e), H = (e) => C(e) ? e : null, S = (e) => typeof e == "string" && ["redirect", "closeModal"].includes(e), U = (e) => S(e) ? e : null, f = (e) => typeof e == "string" ? e : null, j = ({
  checkoutUrl: e,
  displayOptions: r,
  onCancel: t,
  onSuccess: o
}) => {
  if (!e) return null;
  if (r.type === "embedded")
    return /* @__PURE__ */ c(
      x,
      {
        onCancel: t,
        onSuccess: o,
        checkoutUrl: e,
        displayOptions: r
      }
    );
  if (r.type === "modal")
    return /* @__PURE__ */ c(
      R,
      {
        onCancel: t,
        onSuccess: o,
        checkoutUrl: e,
        displayOptions: r
      }
    );
};
export {
  j as IvyCheckout
};
